import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=43f2dafb&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioGroup.vue?vue&type=style&index=0&id=43f2dafb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2dafb",
  null
  
)

export default component.exports